// extracted by mini-css-extract-plugin
module.exports = {"PhoneSection":"PhoneSection_PhoneSection__NrPHG"};